export default "ALTER TABLE `function` RENAME TO `tool`;--> statement-breakpoint\nALTER TABLE `tool` ADD `is_deleted` integer DEFAULT false NOT NULL;"